import { isValidNameFormat } from "@src/constants";

interface NameValidationOptions {
  requiredMessage: string;
  invalidMessage: string;
  maxLength?: number;
}

export const validateName = (
  value: string,
  { requiredMessage, invalidMessage, maxLength }: NameValidationOptions,
): string | undefined => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return requiredMessage;
  }
  if (!isValidNameFormat(trimmedValue)) {
    return invalidMessage;
  }
  if (maxLength && trimmedValue.length > maxLength) {
    return `Name cannot be longer than ${maxLength} characters`;
  }

  return undefined;
};
